import { render } from "./CreateHousePage.vue?vue&type=template&id=9526a0a8"
import script from "./CreateHousePage.vue?vue&type=script&lang=js"
export * from "./CreateHousePage.vue?vue&type=script&lang=js"
script.render = render

export default script